import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3",
  style: {"transform":"rotate(60deg)","font-size":"0.7rem"}
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.bankFlows.datasets)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mb-2",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "d-flex" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "11" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_ctx.displayData)
                      ? (_openBlock(), _createBlock(_component_LineChart, {
                          key: 0,
                          data: _ctx.bankFlows,
                          options: _ctx.options,
                          height: _ctx.bankFlows.datasets.length * 30
                        }, null, 8, ["data", "options", "height"]))
                      : (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" Aucune donnée disponible ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                md: "11",
                cols: "12",
                class: _normalizeClass({ 'pl-13': !_ctx.$vuetify.display.mobile, 'px-2': _ctx.$vuetify.display.mobile })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_range_slider, {
                    modelValue: _ctx.dateRange,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
                    min: "0",
                    max: _ctx.dates.length - 1,
                    "track-color": "#CCC",
                    ticks: _ctx.dateTicksLabels
                  }, {
                    "tick-label": _withCtx(({ tick: { value, position, label }, index: number }) => [
                      (_ctx.$vuetify.display.mobile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(label), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(label), 1))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "max", "ticks"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                md: "1",
                cols: "12",
                class: "d-flex justify-end flex-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass({
                        'ml-4 mr-2 mt-2': !_ctx.$vuetify.display.mobile,
                        'mx-2 my-2': _ctx.$vuetify.display.mobile,
                    }),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSlider())),
                    size: "x-small"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("rafraichir")
                    ])),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}